import { Stack, Tooltip, Typography } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { WarningIcon } from 'modules/ui/src/theme/overrides/CustomIcons'
import { FC } from 'react'

export type VisitDataHeaderCardProps = {
  title: string
  width?: string
  height?: string
  warningText?: string
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
}

export const VisitDataHeaderCard: FC<VisitDataHeaderCardProps> = observer(props => {
  const {
    title,
    width = '255px',
    height = '56px',
    warningText,
    children,
    onClick,
    disabled,
  } = props
  const theme = useMinimalsTheme()

  const borderStyle = warningText
    ? `1px solid ${theme.palette.warning.main}`
    : `1px solid ${theme.palette.grey[300]}`

  return (
    <Tooltip title={warningText} placement='top'>
      <Stack
        direction='row'
        alignItems='center'
        position='relative'
        gap={theme.customSpacing.l}
        border={borderStyle}
        borderRadius={theme.customRadius.medium}
        padding={theme.customSpacing.xs}
        bgcolor={theme.palette.background.paper}
        width={width}
        height={height}
        onClick={disabled ? undefined : onClick}
        sx={{
          cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : 'default',
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <Stack
          direction='row'
          position='absolute'
          top={'-8px'}
          spacing={theme.customSpacing.xxxs}
          bgcolor={theme.palette.background.paper}
          ml={theme.customSpacing.xs}
        >
          <Typography variant='captionBold' color={theme.palette.text.secondary}>
            {title}
          </Typography>
          {warningText && <WarningIcon sx={{ fontSize: '16px' }} color='warning' />}
        </Stack>
        {children}
      </Stack>
    </Tooltip>
  )
})
